import type { ReceiverInput } from "@pdfking/functionpool"
import type { PdfEngine } from "../../types/engine/PdfEngine"
import type { VirtualFile } from "../../types/files/VirtualFile"
import type { TaskResult } from "../../types/tasks/input/TaskResult"
import type { TaskZipOptions } from "../../types/tasks/options/TaskZipOptions"
import type { TrackingCallback } from "../../types/tasks/tracking/TrackingCallback"
import { BlobArray, BlobToUint8 } from "@pdfking/compatibility"
import { MapAsync, ZipCreate } from "@pdfking/tfunc"
import { GenerateFile } from "../../files/GenerateFile"
import { RequestBlob } from "../../files/RequestBlob"
import { ContentType } from "../../types/files/ContentType"
import { VirtualFileType } from "../../types/files/VirtualFileType"
import { TaskName } from "../../types/tasks/TaskName"
import { TrackedTaskName } from "../../types/tasks/tracking/TrackedTaskName"

// options CompressFilesOptions
// stream GenericFile (content_id, content_type)
// emit TrackingCallback
//
// return GenericFile

export async function* TaskZip(
  engine: PdfEngine,
  _task: TaskZipOptions,
  emit: TrackingCallback,
  messages: ReceiverInput<TaskResult>
): AsyncGenerator<TaskResult> {
  const files: Record<string, VirtualFile> = {}

  async function* toZip(): Parameters<typeof ZipCreate>[0] {
    let done = 0
    const load = (done = 0) =>
      emit({
        done,
        name: TrackedTaskName.COMPRESS,
        total: undefined,
      })

    void load(done)

    for await (const { content, name } of messages) {
      const { stream } = await RequestBlob(engine, content, emit)
      yield {
        chunks: MapAsync(BlobToUint8, stream),
        name,
      }
      files[name] = content

      void load((done += 1))
    }
  }

  const content = await GenerateFile(
    engine,
    MapAsync(a => BlobArray(a), ZipCreate(toZip())),
    ContentType.ZIP,
    emit
  )

  yield {
    content: {
      content,
      enum: VirtualFileType.ZIP_FILE,
      file_meta: {},
      files,
    },
    enum: TaskName.CONTENT_FILE,
    name: "merge.zip",
  }
}
